import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDate(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M18 4h1c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2l.01-14c0-1.1.88-2 1.99-2h1V3c0-.55.45-1 1-1s1 .45 1 1v1h8V3c0-.55.45-1 1-1s1 .45 1 1v1Zm0 16c.55 0 1-.45 1-1V9H5v10c0 .55.45 1 1 1h12Zm-9-7v-2H7v2h2Zm2-2h2v2h-2v-2Zm6 2v-2h-2v2h2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
